import { createSlice } from "@reduxjs/toolkit"

const initialState: {
  recipient?: {
    entity_no: string
    name: string
  }
  badge?: Metricate.Badge
} = {
  recipient: undefined,
  badge: undefined,
}

const awardBadgeSlice = createSlice({
  name: "awardBadge",
  initialState,
  reducers: {
    setBadge(state, action) {
      state.recipient = action.payload.recipient
      state.badge = action.payload.badge
    },
  },
})

export const { setBadge } = awardBadgeSlice.actions
export default awardBadgeSlice.reducer
